import React from 'react';
import { Link } from 'react-router-dom';
import './AboutUsLanding.css';

const AboutUsLanding = () => {
  return (
    <div className="about-landing">
      <div className="about-landing-content">
        <div className="about-landing-text">
          <h1 className="about-landing-title">Who We Are</h1>
          <p className="about-landing-lead">
            Adamant HR Consulting Pvt. Ltd. is a premier workforce and compliance
            solutions organisation offering integrated HR, BGV, Payroll, Security,
            Facility, Legal, Health, and Construction services across India.
          </p>
          <p className="about-landing-p">
            For over a decade, we have partnered with leading brands across BFSI,
            NBFC, FMCG, Manufacturing, Logistics, Retail, Pharma, and Service
            sectors, helping them build high-performing, verified, and compliant
            teams.
          </p>
          <Link to="/employers" className="about-landing-btn">
            Get in Touch
          </Link>
        </div>
        <div className="about-landing-image">
          <img src={`${process.env.PUBLIC_URL || ''}/images/smilingfaces.png`} alt="Adamant HR team" />
        </div>
      </div>
    </div>
  );
};

export default AboutUsLanding;
